import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { GroupsService } from '../../../services/groups.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'app-groups-detail',
  templateUrl: './groups-detail.component.html',
    styleUrls: ['./groups-detail.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class GroupsDetailComponent implements OnInit {

    public url: any;
    public isProfile = false;
    public isMutualFriend = false;
    public isActiveFeed = false;
    public isIntroProfile = false;
    public isFollowers = false;
    public isFollowings = false;
    public isLatestPhotos = false;
    public isFriends = false;

    public active = 1;

    readUrl(event: any) {
        if (event.target.files.length === 0)
            return;
        //Image upload validation
        var mimeType = event.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            return;
        }
        // Image upload
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
            this.url = reader.result;
        }
    }

















    constructor(private route: ActivatedRoute,
        private router: Router, private groupsService: GroupsService,
        private authentication: AuthenticationService,
        private common: CommonService) { }

    id: string = "0";

    pagecode: string = "grp-detail";
    module: string = "groups";
    accessdenied: boolean = false;

    ngOnInit(): void {

        let map: any = this.route.paramMap;
        this.id = map.destination._value.id;

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        // load page data

                        this.getGroupById();
                        //

                        window.scroll(0, 0);
                    }
                    else
                        this.accessdenied = true;
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });



    }

    group: any = {
        coverPhoto: "",
        logo: "",
        groupId: "",
        title: "",
        description: "",
        type: "",
        privacy: "",
        createdDate: "",
        updatedDate: ""
    };

    //groupMembers: any[] = [];


    getGroupById() {
        this.groupsService.getGroupById(this.id).subscribe(
            (res: any) => {
                //console.log("Web/Groups/getGroupById()", res);
                if (res.success) {
                    this.group = res.data;
                    this.group.coverPhoto = "url('" + res.data.coverPhoto + "')";
                    this.group.logo = res.data.logo;
                }
                else {
                    console.error("Web/groups/getGroupById()", res.error_message);
                }
            },
            (err: any) => {
                console.error("Web/Groups/getGroupById()", err);
            },
        );
    }


}
